// fixed-data-table2 vertical definitions
export const HEADER_HEIGHT = 26;
export const ROW_HEIGHT = 26;
export const DEFAULT_PADDING = 20;

// configurations for column width calculations
export const HEADER_PADDING = 36;
export const HEADER_TYPE_ICON_SPACING = 29;
export const DATA_PADDING = 24;
export const MAX_WIDTH = 350;
export const MIN_WIDTH = 126;

// temp until we have column adjustment
export const HEADER_ELLIPSIZED_LENGTH = 38;
export const DATA_ELLIPSIZED_LENGTH = 55;
